module.exports = __webpack_public_path__ + "img/feather.a5292cf3.svg";